/**
 * Tradução PT-BR dos status do domínio de compras (header de cotação, proposta,
 * item do pedido). Mantido fora do componente para permitir reuso em outras
 * telas (listagem, detalhes, modais) e em testes.
 *
 * Estratégia:
 *  - chave em lower-case para tolerar variações de casing do backend (`Selected`,
 *    `SELECTED`, `selected`);
 *  - quando o status não tem mapeamento explícito, o valor original do backend
 *    é devolvido (com a primeira letra em maiúscula) — assim a UI nunca quebra.
 */
const SHOPPING_STATUS_MAP_PT: Readonly<Record<string, string>> = {
  // Header do processo de cotação
  open: 'Aberto',
  aberto: 'Aberto',
  closed: 'Encerrado',
  encerrado: 'Encerrado',
  cancelled: 'Cancelado',
  canceled: 'Cancelado',
  cancelado: 'Cancelado',

  // Propostas / quotations
  received: 'Recebida',
  recebida: 'Recebida',
  rejected: 'Rejeitada',
  rejeitada: 'Rejeitada',
  selected: 'Selecionada (vencedora)',
  selecionada: 'Selecionada (vencedora)',
  winner: 'Vencedora',
  vencedora: 'Vencedora',
  pending: 'Pendente',
  pendente: 'Pendente',

  // Itens do pedido (quando o backend traz status do item)
  approved: 'Aprovado',
  aprovado: 'Aprovado',
  requested: 'Solicitado',
  solicitado: 'Solicitado',
  inquotation: 'Em cotação',
  in_quotation: 'Em cotação',
  emcotacao: 'Em cotação',
  inpurchase: 'Em compra',
  in_purchase: 'Em compra',
  emcompra: 'Em compra'
};

/**
 * Traduz um status técnico (PT ou EN) para a versão amigável em PT-BR.
 * Quando o status é desconhecido, devolve o valor original com primeira
 * letra em maiúscula (fallback seguro).
 */
export function translateShoppingStatus(value: string | null | undefined): string {
  const raw = (value ?? '').trim();
  if (!raw) return '—';
  const key = raw.toLowerCase().replace(/[\s-]/g, '');
  const mapped = SHOPPING_STATUS_MAP_PT[key];
  if (mapped) return mapped;
  return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
}
